import { Component } from '@angular/core';
import { CrmAppComponent } from '@touch4it/ng-swp/core';

@Component({
  selector: 'app-root',
  template: '<crm-app></crm-app>',
  imports: [CrmAppComponent],
})
export class AppComponent {}
